import { ExternalScript } from '../store/config/config.reducer';

const source = `
      (function () {
        function getCookie(name) {
          const value = '; ' + document.cookie;
          const parts = value.split('; ' + name + '=');
          if (parts.length === 2) {
            return parts.pop().split(";").shift();
          }
          return null;
        }

        function processUserId(userId) {
          if (!userId) return;
          try {
            document.cookie = 'mm_bc_user_sha' + '=' + userId + '; path=/; max-age=31536000; Secure; SameSite=Lax';
          } catch (e) {
            console.error(e);
          }
        }

        const existingValue = getCookie('mm_bc_user_sha');
        if (existingValue) {
          processUserId(existingValue); // updates expiration date
          return;
        }

        // Scan full dataLayer for bc_reg_user_id (handles merged state from GTM/Connections)
        function syncFromDataLayer() {
          if (getCookie('mm_bc_user_sha')) return;
          if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;
          const found = window.dataLayer.find(function (e) { return e && e.bc_reg_user_id; });
          if (found) processUserId(found.bc_reg_user_id);
        }

        syncFromDataLayer();
        if (getCookie('mm_bc_user_sha')) return;

        // Intercept future pushes: scan entire dataLayer each time (not just the pushed object)
        // so we catch bc_reg_user_id if it appears after the push.
        if (window.dataLayer) {
          const originalPush = window.dataLayer.push;
          window.dataLayer.push = function () {
            const result = originalPush.apply(window.dataLayer, arguments);
            syncFromDataLayer();
            return result;
          };
        }
     })();
  `;

export function updateBCHemCookie(): ExternalScript {
    return {
      type: 'code',
      name: 'update-hem-cookie', // hem, hashed email, is used by the BI team
      source,
      attributes: null,
      loadingType: 'async',
    };
  }
